import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import ReactPlayer from "react-player/vimeo";
import Color from "../../../../assets/colors";

export const ArrowBackStyled = styling(ArrowBackIos)({
  fontSize: "50px",
});

export const ArrowNextStyled = styling(ArrowForwardIos)({
  fontSize: "50px",
});

export const LeftButtonContainer = styling(Grid)((props) => ({
  color: Color.white,
  position: "absolute",
  top: "50%",
  cursor: "pointer",
  left: "50px",

  [props.theme.breakpoints.down("lg")]: {
    left: "20px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    top: "calc(50% - 20px)",
    left: "0px",
    transform: "scale(0.5)",
  },
}));

export const RightButtonContainer = styling(Grid)((props) => ({
  color: Color.white,
  position: "absolute",
  top: "50%",
  cursor: "pointer",
  right: "50px",

  [props.theme.breakpoints.down("lg")]: {
    right: "10px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    top: "calc(50% - 20px)",
    right: "-10px",
    transform: "scale(0.5)",
  },
}));

export const MediaContainer = styling(Grid)({
  width: "80%",
  height: "80%",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const CircularProgressStyled = styling(CircularProgress)({
  color: Color.white,
});

export const ImageStyled = styling("img")({
  objectFit: "contain",
  width: "100%",
  height: "100%",
});

export const ReactPlayerStyled = styling(ReactPlayer)({
  width: "100% !important",
  height: "100% !important",
  objectFit: "contain",
  overflow: "hidden",
});

export const CloseIconStyled = styling(CloseIcon)({
  color: Color.white,
  fontSize: "50px",
  position: "absolute",
  top: 10,
  right: 10,
  cursor: "pointer",
});

export const TypographyStyled = styling(Typography)((props) => ({
  fontSize: "24px",
  color: Color.white,
  textShadow: "1px 0px 8px rgba(0, 0, 0, 1)",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "18px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "14px",
  },
}));
